import React from 'react';
import FileSaver from 'file-saver';
import ExcelJS from 'exceljs';
import { Table, TableHead, TableRow, TableCell, TableBody, Paper, TableContainer, Box, Button } from '@mui/material';
import { DateTime } from 'luxon';

// Tabla genérica: las columnas y las filas vienen del backend (getColumnas /
// mapearFilas de la entidad), por lo que la pantalla muestra EXACTAMENTE la
// misma estructura que el Excel de esa entidad. El export reusa esas columnas.

function exportarExcel(columnas, filas, entidadSeleccionada) {
  const entidadNombre = entidadSeleccionada?.nombre || 'Entidad';
  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet('Alertas');
  sheet.columns = columnas; // [{ header, key }]
  (filas || []).forEach(fila => sheet.addRow(fila));
  const nombreArchivo = `Alertas_${entidadNombre}_${DateTime.now().toFormat('yyyyMMdd_HHmm')}.xlsx`;
  workbook.xlsx.writeBuffer().then(data => {
    FileSaver.saveAs(new Blob([data]), nombreArchivo);
  });
}

function AlertasTable({ alertas = [], columnas = [], entidadSeleccionada }) {
  if (!columnas.length) {
    return <div>No hay estructura de reporte para esta entidad</div>;
  }

  return (
    <Paper elevation={3} sx={{ overflow: 'hidden', borderRadius: 2, border: '1px solid', borderColor: 'divider', mb: 3, width: '100%' }}>
      <Box sx={{ display: 'flex', justifyContent: 'flex-start', p: 2 }}>
        <Button
          variant="contained"
          color="primary"
          disabled={!alertas.length}
          onClick={() => exportarExcel(columnas, alertas, entidadSeleccionada)}
        >
          Exportar
        </Button>
      </Box>
      <TableContainer sx={{ maxHeight: 600 }}>
        <Table stickyHeader size="small">
          <TableHead>
            <TableRow sx={{
              '& th': {
                backgroundColor: 'primary.main',
                color: 'primary.contrastText',
                fontWeight: 'fontWeightBold',
                fontSize: '0.8rem',
                whiteSpace: 'nowrap'
              }
            }}>
              {columnas.map(col => (
                <TableCell key={col.key}>{col.header}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {alertas.map((fila, idx) => (
              <TableRow key={idx} hover sx={{ '& td': { whiteSpace: 'nowrap' } }}>
                {columnas.map(col => (
                  <TableCell key={col.key}>
                    {fila[col.key] ?? ''}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}

export default AlertasTable;
